/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type settlingin_CompletePlanWarningDTO = {
    count?: number;
    message?: string;
    type?: settlingin_CompletePlanWarningDTO.type;
};
export namespace settlingin_CompletePlanWarningDTO {
    export enum type {
        SIGN_OFF_MISSING = 'sign_off_missing',
        FUTURE_SCHEDULE_ENTRIES = 'future_schedule_entries',
    }
}

